import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";
const AttendanceModule = React.lazy(() => import("./Attendence"));
const Present = React.lazy(() => import("./Present"));
const MyAttendence = React.lazy(() => import("./Attendence/MyAttendance"));
export const AttendanceConfigs = [
    {
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.HR_MANAGER,
            // RoutePermittedRole.LOCATION_MANAGER,
        ],
        path: "/attendance",
        element: <AttendanceModule />,
    },
    {
        permittedRole: [
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        path: "/my-attendance",
        element: <MyAttendence />,
    },
    {
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.LOCATION_MANAGER,
        ],
        path: "/present",
        element: <Present />,
    },
];
